export class VendorMappingChange {
  userId: number;
  vendorId: string;
}
